import React from 'react';
import './SearchEventCardDebugInfo.scss';

const getReactKey = (level: number, index: number) =>
    `search-debug-key-${level}-${index}`;

const MaxOrSumComponent = ({
    detail,
    recurse,
}: {
    detail: { label: string; value: string; children: React.ReactNode };
    recurse: Function;
}) => {
    const label = detail.label;
    const value = detail.value;

    return (
        <div className="eds-l-mar-hor-1">
            {value && (
                <div className="search-event-card-debug-info__relevance-column--should-underline eds-l-mar-top-1">
                    <div>{Number(value).toPrecision(4)}</div>
                </div>
            )}
            {label && <div>{label}</div>}
            <div className="search-event-card-debug-info__relevance-row">
                {detail.children && recurse(detail.children, detail)}
            </div>
        </div>
    );
};

const renderDetail = ({
    detail,
    recurse,
    reactKey,
}: {
    detail: { label: string; value: string; children: React.ReactNode };
    recurse: Function;
    reactKey: string;
}) => {
    return (
        <MaxOrSumComponent key={reactKey} detail={detail} recurse={recurse} />
    );
};

const extractTermsFromRelevanceScore = (
    children: any,
    parentDetail: string, // eslint-disable-line @typescript-eslint/no-unused-vars
    level = 0,
) =>
    children.map(
        (
            detail: { label: string; value: string; children: React.ReactNode },
            index: number,
        ) =>
            renderDetail({
                detail,
                reactKey: getReactKey(level, index),
                recurse: (children: React.ReactNode, parentDetail: string) =>
                    extractTermsFromRelevanceScore(
                        children,
                        parentDetail,
                        level + 1,
                    ),
            }),
    );

export const getRelevanceComponents = (esDebugInfo: any) => {
    return (
        <div className="search-event-card-debug-info__relevance-components-container">
            {renderDetail({
                detail: esDebugInfo,
                reactKey: getReactKey(0, 0),
                recurse: (children: React.ReactNode, parentDetail: string) =>
                    extractTermsFromRelevanceScore(children, parentDetail, 1),
            })}
        </div>
    );
};

const SearchEventCardDebugRelevanceInfo = (props: {
    position?: string | number;
    debugInfo: any;
    numFollowers: string | number;
}) => (
    <div className="search-event-card-debug-info eds-l-pad-bot-1">
        <div className="eds-l-mar-all-1 eds-text-color--ui-orange eds-align--center eds-text-weight--heavy">
            #{props.position}
        </div>
        <div className="search-event-card-debug-info__relevance">
            {getRelevanceComponents(props.debugInfo.esDebugInfo)}
        </div>
        <div>
            Organizer has:{' '}
            <strong>{props?.numFollowers || '0'} followers</strong>
        </div>
    </div>
);

export default SearchEventCardDebugRelevanceInfo;
